import { AbgSxProps } from '@abg/typings';

export const dateTimeDrawerStyles: AbgSxProps = {
  width: '100%',
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const drawerIconContainerStyles: AbgSxProps = {
  marginBottom: '14px',
  paddingTop: '21px',
  paddingLeft: '16px',
};

export const backIconStyles: AbgSxProps = {
  padding: '5px',
  minWidth: 'unset !important',
  '.MuiTouchRipple-root': {
    display: 'none',
  },
  '&:focus': {
    outline: 'none',
  },
};

export const accordionsContainerStyles: AbgSxProps = {
  flexGrow: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  borderTop: '1px solid #C7C5C5',
};

export const locationTimeOptionStyles: AbgSxProps = {
  py: '14px',
  pl: '16px',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'block',
  width: '100%',
  textAlign: 'start',
};
